import { render, staticRenderFns } from "./createAccount.vue?vue&type=template&id=305bc0f9"
import script from "./createAccount.vue?vue&type=script&lang=js"
export * from "./createAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports